import type { VideoItem } from "@/types/video";

export default function VideoPlayer({ video }: { video: VideoItem }) {
  return (
    <div className="overflow-hidden rounded-xl bg-foreground-950">
      <video
        key={video.id}
        className="aspect-video w-full bg-foreground-950"
        controls
        playsInline
        preload="metadata"
        poster={video.cover}
      >
        <source src={video.videoUrl} type="video/mp4" />
        你的浏览器暂不支持 HTML5 视频播放，请更换较新的浏览器后再试。
      </video>
      <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-3">
        <p className="flex items-center gap-1.5 font-label text-[11px] tracking-wide text-foreground-300">
          <i className="ri-hd-line text-base text-accent-400"></i>
          演示视频源 · 支持播放、暂停、音量与进度调节
        </p>
        <p className="font-label text-[11px] tracking-wide text-foreground-400">
          HTML5 PLAYER / MP4
        </p>
      </div>
    </div>
  );
}